import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/mdh/Nav";

export default function LegalLayout({ title, updated, testid, children }) {
    return (
        <div data-testid={testid} className="relative min-h-screen">
            <div className="bg-grid-slate pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" />
            <header className="relative mx-auto flex h-16 max-w-3xl items-center justify-between px-5 lg:px-8">
                <Logo />
                <Link
                    to="/"
                    className="flex items-center gap-1.5 font-mono text-[11px] text-slate-500 hover:text-cyan-300"
                >
                    <ArrowLeft className="h-3 w-3" /> Home
                </Link>
            </header>
            <div className="relative mx-auto max-w-3xl px-5 pb-24 pt-10 lg:px-8">
                <h1 className="font-hero text-3xl font-bold tracking-tight text-slate-100 sm:text-4xl">
                    {title}
                </h1>
                <p className="mt-2 font-mono text-[11px] text-slate-500">Last updated: {updated}</p>
                <div className="legal-body mt-8 space-y-6 text-sm leading-relaxed text-slate-400 [&_h2]:pt-2 [&_h2]:font-display [&_h2]:text-base [&_h2]:font-bold [&_h2]:text-slate-100 [&_a]:text-cyan-300 [&_a]:underline [&_a]:underline-offset-2">
                    {children}
                </div>
            </div>
        </div>
    );
}
